import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
//import { Component, OnInit, Optional, ElementRef, Input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ContractDTO } from '../../../api/plyca-dtos-v2';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../baseFormComponent/baseForm.component';
import { ReceiptDTO } from '../model/receipt.model';
import { FormConfig } from '../../../components/forms/form.objects';
import { TaskDTO, getParentIdentifierFromString, getSimpleIdentifierFromString } from '../../../api/plyca-dtos';
import { ProjectOrganizationalSnapshotValidations } from '../../projectOrganizationalSnapshot/component/projectOrganizationalSnapshot.validation';


export class ReceiptModel {
  dto: ReceiptDTO;
  ui: {
    divisionId?: string,
    dossierId?: string,
    edition?: boolean;
    isModeError?: boolean;
    isREPLYCATask?: boolean;
    isProjectReplyca?: boolean;
    receiptTypeTask?: string;
    selectedReceiptType?: string;
    excludedReceiptType?: string;
    isEditReceiptType?: boolean;
    contractModificationType?: string;
    activeTemporayPeriodOrganizationalChange?: boolean;
    enabledPreviousOrganizationalUnitRegistration?: boolean;
    selectedProjectOrganizationalSnapshot?: any;
  };
}

@Component({
  selector: 'receipt',
  templateUrl: '../../../dossiers/registerContractModifications/registerContractModification.template.html',
  providers: [ProjectOrganizationalSnapshotValidations]
  //\app\dossiers\registerContractModifications\registerContractModification.template.html
  //\app\tasks\receipt\component\receipt.component.ts
})

export class ReceiptComponent extends BaseFormComponent<ReceiptDTO, ReceiptModel>
  implements OnInit, OnDestroy {

  private contract: ContractDTO;

  constructor(
    private projectOrganizationalSnapshotValidations: ProjectOrganizationalSnapshotValidations,
    elem: ElementRef) {
    super(elem);
  }



  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    this.loadFunctions(formConfig);
    return super.configureFormConfig(formConfig);
    /*formConfig.functions.push({
      identifier: 'isVacio',
      fn: this.isVacio.bind(this)
    });
    formConfig.functions.push({
      identifier: 'loadOrganizationalSnapshotData',
      fn: this.loadOrganizationalSnapshotData
    });
    formConfig.functions.push({
      identifier: 'changeProjectOrganizationalSnapshot',
      fn: this.changeProjectOrganizationalSnapshot
    });
    return of(formConfig);*/
  }

  //Funciones


  loadFunctions(_formConfig: FormConfig) {
    console.log('loadFunctions');
    _formConfig.functions.push({
      identifier: 'loadOrganizationalSnapshotData',
      fn: this.projectOrganizationalSnapshotValidations.loadOrganizationalSnapshotData
    });
    _formConfig.functions.push({
      identifier: 'changeProjectOrganizationalSnapshot',
      fn: this.projectOrganizationalSnapshotValidations.changeProjectOrganizationalSnapshot
    });
    _formConfig.functions.push({
      identifier: 'visiblePreviousOrganizationalUnitRegistration',
      fn: this.projectOrganizationalSnapshotValidations.visiblePreviousOrganizationalUnitRegistration
    });


  }

  ngOnInit(): void {
    if (this.task && this.task.work && this.task.work.contract) {
      console.log('INVOCACION DE RECEIPT DESDE TAREA', this.task);
      //this.workRegisterContractModification = this.task.work;
      //this.identifier = this.task.work.registerContractModification.identifier;
      this.contract = this.task.work.contract;
    }
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearWindowActions(this.modalWindowHash);
    super.ngOnDestroy();
  }

  getFormSettingURL(): string {
    return 'receipt/receiptSettings.json';
  }
  getServiceURL(): string {
    return undefined;
  }
  getObjectIdentifier() {
    return undefined;
  }
  dtoToModel(dto: ReceiptDTO): Observable<ReceiptModel> {
    let model = new ReceiptModel();

    // TODO ver si WorkReceipt hay que incluirlo en plyca-dtos.ts
    model.dto = this.task.work['receipt'];

    model.ui = {
      edition: true,
      isModeError: false,
      isREPLYCATask: false,
      isProjectReplyca: false,
      receiptTypeTask: null,
      selectedReceiptType: null,
      excludedReceiptType: null,
      isEditReceiptType: true,
      contractModificationType: null,
      activeTemporayPeriodOrganizationalChange: false,
      enabledPreviousOrganizationalUnitRegistration: false,
      selectedProjectOrganizationalSnapshot: new Object()
    };

    if (this.task && this.task.work) {

      model.ui.contractModificationType = this.translate.instant('Receipt.detail.contractModificationType.value');

      if (this.task.work.context && this.task.work.context.configurations) {
        if (this.task.work.context.configurations['screenMode']) {
          if (this.task.work.context.configurations['screenMode'].value == 'RECTIFICA' || this.task.work.context.configurations['screenMode'].value == 'ANULA') {
            model.ui.isModeError = true;
            if (this.task.work.context.configurations['screenMode'].value == 'ANULA') {
              model.ui.edition = false;
            }
          }
        }
        if (this.task.work.context.configurations['isREPLYCATask'].value == '1') {
          model.ui.isREPLYCATask = true;
        }
        if (this.task.work.context.configurations['isProjectReplyca'].value == '1') {
          model.ui.isProjectReplyca = true;
        }
        /* La precarga del tipo de recepción se  hace en servidor
         if ((model.dto.receiptType == null || model.dto.receiptType == undefined) && this.task.work.context.configurations['receiptTypeTask']) {
           model.ui.receiptTypeTask = this.task.work.context.configurations['receiptTypeTask'].value;
           model.dto.receiptType.identifier = model.ui.receiptTypeTask;
         }

         // Machacamos el valor receiptType calculado a partir de receiptTypeTask con selectedReceiptType
         if ((model.dto.receiptType == null || model.dto.receiptType == undefined) && this.task.work.context.configurations['selectedReceiptType']) {
           model.ui.selectedReceiptType = this.task.work.context.configurations['selectedReceiptType'].value;
           model.dto.receiptType.identifier = model.ui.selectedReceiptType;
         }*/

        if (this.task.work.context.configurations['excludedReceiptType']) {
          model.ui.excludedReceiptType = this.task.work.context.configurations['excludedReceiptType'].value;
        }

        if (this.task.work.context.configurations['isEditReceiptType']) {
          if (this.task.work.context.configurations['isProjectReplyca'].value == '0') {
            model.ui.isEditReceiptType = false;
          }
        }

        model.ui.divisionId = getSimpleIdentifierFromString(model.dto.division.identifier);
        model.ui.dossierId = this.normalizaDossierId(getParentIdentifierFromString(model.dto.division.identifier));


        if (model.dto?.context && model.dto.context.configurations['activeTemporayPeriodOrganizationalChange']) {
          model.ui.activeTemporayPeriodOrganizationalChange = model.dto.context.configurations['activeTemporayPeriodOrganizationalChange'].value;
          if (model.ui.activeTemporayPeriodOrganizationalChange) {
            model.ui.enabledPreviousOrganizationalUnitRegistration = true;
          } else {
            if (model.dto.previousOrganizationalUnitRegistration !== undefined) {
              //No está activo, pero el campo se ha visualizado en algun monmento: subsanacion
              model.ui.enabledPreviousOrganizationalUnitRegistration = false;
            }
          }
        }

        model.ui.selectedProjectOrganizationalSnapshot = model.dto.projectOrganizationalSnapshot;

        /*console.log('****************************************************************');
        console.log('****************************************************************');
        console.log('****************************************************************');
        console.log('****************************************************************');
        console.log('Tipo de recepción a seleccionar', model.ui.receiptTypeTask);
        console.log('Tipo de recepción a seleccionar', model.ui.selectedReceiptType);
        console.log('Tipo de recepción a seleccionar', model.ui.excludedReceiptType);
        console.log('Tipo de recepción a seleccionar', model.ui.isEditReceiptType);
        console.log('****************************************************************');
        console.log('****************************************************************');
        console.log('****************************************************************');
        console.log('****************************************************************');
        console.log('****************************************************************');*/
      }
    }
    return of(model);
  }
  modelToDTO(model: ReceiptModel): ReceiptDTO {
    return model.dto;
  }
  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Receipt.detail.title';
    headerInfo.titleIcon = 'fas fa-hand-holding';
    headerInfo.project = this.model.dto.division.project;
    return headerInfo;
  }

  protected updateTask(updatedTask: TaskDTO) {
    this.formService.merge(this.task, updatedTask);
  }

  initHeaderActions() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.accept',
        'fas fa-lg fa-check',
        'btn-primary',
        true,
        this.windowHash
      ),
      success => {
        this.processTask();
      });
    this.headerActionsService.addDivider();
    this.addBackAction();
  }

  isVacio(model: any) {
    console.log('EJECUTADO isVacio', model);
    return false;
  }

  normalizaDossierId(dossierId: string): string {
    return dossierId.substring(0, 4) + '/' + dossierId.substring(4);
  }

}